// extracted by mini-css-extract-plugin
export default {"container":"pNFfYH","logoTitle":"ZB5Dyd","logo":"VEYSLL","linksTitle":"c_sagE","links":"NxHS_j","primaryMenu":"kVpkx7","secondaryMenu":"lvJp9X"};